import { allowedOperatorCodes, createPhoneMask, name as nameValidation } from '../validation';

export default function footerCallback({main, elm}) {
    const form = elm.querySelector('[data-callback-form]');
    const dialog = elm.querySelector('[data-callback-dialog]');
    const successTitle = elm.querySelector('[data-callback-success-title]');
    const successText = elm.querySelector('[data-callback-success-text]');
    const nameInput = elm.querySelector('[name="name"]');
    const phoneInput = elm.querySelector('[name="phone"]');
    const submitButton = elm.querySelector('[type="submit"]');
    const status = elm.querySelector('[data-callback-status]');
    const action = elm.dataset.action || '';
    let phoneMask = null;
    const successMessage = {
        title: elm.dataset.successTitle || '',
        text: elm.dataset.successText || ''
    };
    const messages = {
        requiredName: elm.dataset.requiredName || '',
        invalidName: elm.dataset.invalidName || '',
        requiredPhone: elm.dataset.requiredPhone || '',
        invalidPhone: elm.dataset.invalidPhone || '',
        invalidOperatorCode: elm.dataset.invalidOperatorCode || ''
    };

    main(() => {
        if (!form || !nameInput || !phoneInput || !action) {
            return;
        }

        if (dialog && dialog.parentNode !== document.body) {
            document.body.appendChild(dialog);
        }

        phoneMask = createPhoneMask(phoneInput);

        if (phoneInput.value.trim()) {
            phoneMask.unmaskedValue = normalizePhone(phoneInput.value);
        }

        phoneInput.addEventListener('focus', onPhoneFocus);
        phoneInput.addEventListener('blur', onPhoneBlur);
        phoneInput.addEventListener('input', onPhoneInput);
        nameInput.addEventListener('input', () => clearFieldError('name'));
        form.addEventListener('submit', onSubmit);

        const closeButtons = dialog ? dialog.querySelectorAll('[data-close]') : [];

        if (dialog && closeButtons.length) {
            closeButtons.forEach((button) => {
                button.addEventListener('click', () => dialog.close());
            });
        }

        if (dialog) {
            dialog.addEventListener('click', (event) => {
                const rect = dialog.getBoundingClientRect();

                if (
                    event.clientX < rect.left ||
                    event.clientX > rect.right ||
                    event.clientY < rect.top ||
                    event.clientY > rect.bottom
                ) {
                    dialog.close();
                }
            });
        }
    });

    function onPhoneFocus() {
        if (phoneMask && !phoneMask.unmaskedValue) {
            phoneMask.unmaskedValue = '380';
        }
    }

    function onPhoneBlur() {
        if (phoneMask?.unmaskedValue === '380') {
            phoneMask.unmaskedValue = '';
        }
    }

    function onPhoneInput() {
        clearFieldError('phone');
    }

    async function onSubmit(event) {
        event.preventDefault();

        clearFieldError('name');
        clearFieldError('phone');
        setStatus('');

        const name = nameInput.value.trim();
        const phone = phoneMask?.unmaskedValue || normalizePhone(phoneInput.value);
        let hasError = false;

        if (!name) {
            setFieldError('name', messages.requiredName);
            hasError = true;
        } else if (!nameValidation.validate(name, nameInput, form)) {
            setFieldError('name', messages.invalidName);
            hasError = true;
        }

        if (!phone) {
            setFieldError('phone', messages.requiredPhone);
            hasError = true;
        } else if (!phoneMask?.masked.isComplete || phone.length !== 12) {
            setFieldError('phone', messages.invalidPhone);
            hasError = true;
        } else if (!allowedOperatorCodes.includes(phone.slice(2, 5))) {
            setFieldError('phone', messages.invalidOperatorCode);
            phoneMask.unmaskedValue = '380';
            hasError = true;
        }

        if (hasError) {
            return;
        }

        togglePending(true);

        try {
            const response = await fetch(action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams({
                    name,
                    phone,
                    page_url: window.location.href
                })
            });

            const json = await response.json();

            if (json?.error?.name) {
                setFieldError('name', json.error.name);
            }

            if (json?.error?.phone) {
                setFieldError('phone', json.error.phone);
            }

			if (json?.error?.rate) {
				alert(json.error.rate);
			}

            if (json?.success) {
                clearFieldError('name');
                clearFieldError('phone');
                setStatus('');
                form.reset();
                if (phoneMask) {
                    phoneMask.unmaskedValue = '';
                }
                openSuccessDialog();
            }

			const callbackEvent = new CustomEvent(
				'call-back', {
					detail: {
						name,
						phone,
					}
				});
			document.dispatchEvent(callbackEvent);
        } catch (error) {
            setStatus(messages.invalidPhone);
        } finally {
            togglePending(false);
        }
    }

    function togglePending(isPending) {
        if (submitButton) {
            submitButton.disabled = isPending;
        }
    }

    function openSuccessDialog() {
        if (successTitle) {
            successTitle.textContent = successMessage.title;
        }

        if (successText) {
            successText.textContent = successMessage.text;
        }

        if (dialog?.showModal) {
            dialog.showModal();
            return;
        }

        window.alert(successMessage.text);
    }

    function setFieldError(field, message) {
        const fieldElement = elm.querySelector(`[data-field="${field}"]`);
        const errorElement = elm.querySelector(`[data-error-for="${field}"]`);

        if (fieldElement) {
            fieldElement.classList.add('form__field--error');
        }

        if (errorElement) {
            errorElement.textContent = message;
        }
    }

    function clearFieldError(field) {
        const fieldElement = elm.querySelector(`[data-field="${field}"]`);
        const errorElement = elm.querySelector(`[data-error-for="${field}"]`);

        if (fieldElement) {
            fieldElement.classList.remove('form__field--error');
        }

        if (errorElement) {
            errorElement.textContent = '';
        }
    }

    function setStatus(message) {
        if (status) {
            status.textContent = message;
        }
    }
}

function normalizePhone(value) {
    const digits = value.replace(/\D+/g, '');

    if (!digits) {
        return '';
    }

    if (digits.startsWith('380')) {
        return digits.slice(0, 12);
    }

    if (digits.startsWith('80')) {
        return `3${digits}`.slice(0, 12);
    }

    if (digits.startsWith('0')) {
        return `38${digits}`.slice(0, 12);
    }

    if (digits.startsWith('38')) {
        return digits.slice(0, 12);
    }

    return `38${digits}`.slice(0, 12);
}

export const model = {};
